import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import { commonService } from '@/service/store.service'

const ArvLayout = () => import('@/layouts/arv.vue')
const DashboardLayout = () => import('@/layouts/dashboard.vue')
const EcoScoreLayout = () => import('@/layouts/ecoscore.vue')
const LsvaLayout = () => import('@/layouts/lsva.vue')
const PrivateLayout = () => import('@/layouts/private.vue')
const PublicLayout = () => import('@/layouts/public.vue')
const RulesLayout = () => import('@/layouts/rules.vue')
const SharingLayout = () => import('@/layouts/sharing.vue')

const AnimalActivityChartView = () =>
    import('../components/asset-types/animal/views/AnimalActivityChartView')
const ArvActivitiesView = () =>
    import('../components/views/arv/ArvActivitiesView')
const ArvDashboardView = () =>
    import('../components/views/arv/ArvDashboardView')
const ArvDeadlinesView = () =>
    import('../components/views/arv/ArvDeadlinesView')
const ArvEvaluationsView = () =>
    import('../components/views/arv/ArvEvaluationsView')
const ArvReportsView = () => import('../components/views/arv/ArvReportsView')
const ArvViolationsView = () =>
    import('../components/views/arv/ArvViolationsView')
const AssetChartsCombinedView = () =>
    import('../components/views/AssetChartsCombinedView')
const AssetChartsView = () => import('../components/views/AssetChartsView')
const AssetCustomMeasurementsChartView = () =>
    import('../components/views/AssetCustomMeasurementsChartView')
const AssetDetailView = () => import('../components/views/AssetDetailView')
const AssetFenceGuardStatusChartView = () =>
    import('../components/views/AssetFenceGuardStatusChartView')
const AssetListView = () => import('../components/views/AssetListView')
const AssetLocationHistory = () =>
    import('../components/views/AssetLocationHistory')
const AssetSchemeView = () => import('../components/views/AssetSchemeView')
const AssetStatusChartView = () =>
    import('../components/views/AssetStatusChartView')
const AssetTachographView = () =>
    import('../components/views/AssetTachographView')
const AssetTypeListView = () => import('../components/views/AssetTypeListView')
const BinFillLevelChartView = () =>
    import('../components/views/BinFillLevelChartView')
const BleHistoryChartView = () =>
    import('../components/views/BleHistoryChartView')
const CM2ChartsView = () =>
    import('../components/asset-types/cm2-humidity/views/CM2ChartsView')
const ChangePasswordView = () =>
    import('../components/views/ChangePasswordView')
const ConnectionHeatmapView = () =>
    import('../components/views/ConnectionHeatmapView')
const CreateLocationView = () =>
    import('../components/views/CreateLocationView')
const DashboardAssetsView = () =>
    import('../components/views/DashboardAssetsView')
const EtruckDashboardView = () =>
    import('../components/views/EtruckDashboardView')
const DashboardGenericChartView = () =>
    import('../components/views/DashboardGenericChartView')
const DashboardLocationHistoryView = () =>
    import('../components/views/DashboardLocationHistoryView')
const DashboardMaintenanceHistoryView = () =>
    import('../components/views/DashboardMaintenanceHistoryView')
const DashboardOverviewView = () =>
    import('../components/views/DashboardOverviewView')
const DashboardReportingHistoryView = () =>
    import('../components/views/DashboardReportingHistoryView')
const DashboardRfidView = () => import('../components/views/DashboardRfidView')
const DashboardSettingsView = () =>
    import('../components/views/DashboardSettingsView')
const DashboardSharingTokensView = () =>
    import('../components/views/DashboardSharingTokensView')
const DashboardTachographHistoryView = () =>
    import('../components/views/DashboardTachographHistoryView')
const DashboardUsersView = () =>
    import('../components/views/DashboardUsersView')
const DriverDetailsView = () =>
    import('../components/views/ax-road/DriverDetailsView')
const EcoScoreArvView = () =>
    import('../components/views/ecoscore/EcoScoreArvView')
const EcoScoreDriverView = () =>
    import('../components/views/ecoscore/EcoScoreDriverView')
const EcoScoreOverviewView = () =>
    import('../components/views/ecoscore/EcoScoreOverviewView')
const EcoScoreTruckView = () =>
    import('../components/views/ecoscore/EcoScoreTruckView')
const DriverTachographView = () =>
    import('../components/views/ax-road/DriverTachographView')
const DriversView = () => import('../components/views/ax-road/DriversView')
const EditAssetView = () => import('../components/views/EditAssetView')
const EditLocationView = () => import('../components/views/EditLocationView')
const LocationDetailView = () =>
    import('../components/views/LocationDetailView')
const LocationHistoryChartView = () =>
    import('../components/views/LocationHistoryChartView')
const LoginView = () => import('../components/views/LoginView')
const LsvaDashboardView = () =>
    import('../components/views/lsva/LsvaDashboardView')
const LsvaOverviewView = () =>
    import('../components/views/lsva/LsvaOverviewView')
const LsvaTrailersView = () =>
    import('../components/views/lsva/LsvaTrailersView')
const LsvaTrucksView = () => import('../components/views/lsva/LsvaTrucksView')
const MessageStreamView = () => import('../components/views/MessageStreamView')
const NavigationView = () => import('../components/views/NavigationView')
const NetworkChartView = () => import('../components/views/NetworkChartView')
const PasswordResetView = () => import('../components/views/PasswordResetView')
const RuleEditView = () => import('../components/views/redesigned/RuleEditView')
const RuleListView = () => import('../components/views/redesigned/RuleListView')
const RuleTemplatesView = () =>
    import('../components/views/redesigned/RuleTemplatesView')
const RunningTimeChartView = () =>
    import('../components/views/RunningTimeChartView')
const RadialSearchView = () =>
    import('../components/views/ax-road/RadialSearchView')
const RadialSearchResultsView = () =>
    import('../components/views/ax-road/RadialSearchResultsView')
const SearchView = () => import('../components/views/SearchView')
const SettingsView = () => import('../components/views/ax-road/SettingsView')
const SharedAssetDetailsView = () =>
    import('../components/views/SharedAssetDetailsView')
const TreeMoistureChartsView = () =>
    import(
        '../components/asset-types/tree-moisture/views/TreeMoistureChartsView'
    )
const TreeTemperatureChartsView = () =>
    import(
        '../components/asset-types/tree-moisture/views/TreeTemperatureChartsView'
    )
const TripHistoryView = () =>
    import('../components/views/ax-road/TripHistoryView')
const TruckDetailsTachographView = () =>
    import('../components/views/ax-road/TruckDetailsTachographView')
const TruckDetailsView = () =>
    import('../components/views/ax-road/TruckDetailsView')
const TruckMeasurementsView = () =>
    import('../components/views/ax-road/TruckMeasurementsView')
const TrucksView = () => import('../components/views/ax-road/TrucksView')
const WarningsView = () => import('../components/views/ax-road/WarningsView')
const ZoneDetailsHistoryView = () =>
    import('../components/views/ax-road/ZoneDetailsHistoryView')
const ZoneDetailsView = () =>
    import('../components/views/ax-road/ZoneDetailsView')
const ZoneEditView = () => import('../components/views/ax-road/ZoneEditView')
const ZonesView = () => import('../components/views/ax-road/ZonesView')

Vue.use(Router)

export const aliasPreservingGuard = (to, from, next) => {
    const id = to.params.id
    if (!id || from.path === to.path) {
        next()
        return
    }

    const idPart = `/${id}`
    const fromIdIndex = from.path.lastIndexOf(idPart)
    const toIdIndex = to.path.lastIndexOf(idPart)
    if (fromIdIndex === -1 || toIdIndex === -1) {
        next()
        return
    }

    const base = from.path.slice(0, fromIdIndex + idPart.length)
    const subroute = to.path.slice(toIdIndex + idPart.length)
    const newPath = base + subroute

    if (newPath === to.path) {
        next()
    } else {
        next({
            path: newPath,
            query: to.query,
            hash: to.hash,
        })
    }
}

export const queryPreservingGuard = (to, from, next) => {
    if (Object.keys(from.query).length && !Object.keys(to.query).length) {
        next({
            ...to,
            query: { ...from.query, ...to.query },
        })
    } else {
        next()
    }
}

const getAssetDetailsAliases = (subroute = '') => {
    return ['asset-types/:assetType/:id', 'location/:locationId/:id'].map(
        alias => `${alias}${subroute}`
    )
}

const router = new Router({
    routes: [
        {
            path: '/map',
            component: PrivateLayout,
            meta: {
                requiresAuth: true,
            },
            beforeEnter: (to, from, next) =>
                store.getters['auth/hasMapAccess'] ? next() : next(false),
            children: [
                {
                    path: 'ax-road/trucks',
                    name: 'axRoadTrucks',
                    components: {
                        parent: TrucksView,
                    },
                },
                {
                    path: 'ax-road/trucks/:id',
                    name: 'axRoadTruckDetails',
                    components: {
                        parent: TrucksView,
                        child: TruckDetailsView,
                    },
                },
                {
                    path: 'ax-road/trucks/:id/trip-history',
                    name: 'axRoadTripHistory',
                    components: {
                        parent: TrucksView,
                        child: TruckDetailsView,
                        subchild: TripHistoryView,
                    },
                },
                {
                    path: 'ax-road/trucks/:id/tachograph',
                    name: 'axRoadTruckTachograph',
                    components: {
                        parent: TrucksView,
                        child: TruckDetailsView,
                        subchild: TruckDetailsTachographView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasTachographAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'ax-road/trucks/:id/measurements',
                    name: 'axRoadTruckMeasurements',
                    components: {
                        parent: TrucksView,
                        child: TruckDetailsView,
                        subchild: TruckMeasurementsView,
                    },
                },
                {
                    path: 'ax-road/drivers',
                    name: 'axRoadDrivers',
                    components: {
                        parent: DriversView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasTachographAccess']
                            ? queryPreservingGuard(to, from, next)
                            : next(false),
                },
                {
                    path: 'ax-road/drivers/:id',
                    name: 'axRoadDriverDetails',
                    components: {
                        parent: DriversView,
                        child: DriverDetailsView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasTachographAccess']
                            ? queryPreservingGuard(to, from, next)
                            : next(false),
                },
                {
                    path: 'ax-road/drivers/:id/tachograph',
                    name: 'axRoadDriverTachograph',
                    components: {
                        parent: DriversView,
                        child: DriverDetailsView,
                        subchild: DriverTachographView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasTachographAccess']
                            ? queryPreservingGuard(to, from, next)
                            : next(false),
                },
                {
                    path: 'ax-road/drivers/:id/trip-history',
                    name: 'axRoadDriverTripHistory',
                    components: {
                        parent: DriversView,
                        child: DriverDetailsView,
                        subchild: TripHistoryView,
                    },
                    props: {
                        subchild: route => {
                            const driver =
                                store.getters['tracker/driversById'][
                                    route.params.id
                                ]
                            const asset =
                                store.getters['tracker/assetsByAssetId'][
                                    driver.last_asset.id
                                ]
                            return { truckId: asset.id }
                        },
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasTachographAccess']
                            ? queryPreservingGuard(to, from, next)
                            : next(false),
                },
                {
                    path: 'ax-road/warnings',
                    name: 'axRoadWarnings',
                    components: {
                        parent: WarningsView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasRulesAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'ax-road/warnings/driver/:id',
                    name: 'axRoadDriverWarnings',
                    components: {
                        parent: WarningsView,
                        child: DriverDetailsView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasRulesAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'ax-road/warnings/driver/:id/tachograph',
                    name: 'axRoadDriverTachographWarnings',
                    components: {
                        parent: WarningsView,
                        child: DriverDetailsView,
                        subchild: DriverTachographView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasRulesAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'ax-road/warnings/truck/:id',
                    name: 'axRoadTruckWarnings',
                    components: {
                        parent: WarningsView,
                        child: TruckDetailsView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasRulesAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'ax-road/warnings/truck/:id/measurements',
                    name: 'axRoadTruckMeasurementsWarnings',
                    components: {
                        parent: WarningsView,
                        child: TruckDetailsView,
                        subchild: TruckMeasurementsView,
                    },
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasRulesAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'ax-road/zones',
                    name: 'axRoadZones',
                    components: {
                        parent: ZonesView,
                    },
                },
                {
                    path: 'ax-road/zones/add',
                    name: 'axRoadAddZone',
                    components: {
                        parent: ZonesView,
                        child: ZoneEditView,
                    },
                },
                {
                    path: 'ax-road/zones/:id',
                    name: 'axRoadZoneDetails',
                    components: {
                        parent: ZonesView,
                        child: ZoneDetailsView,
                    },
                },
                {
                    path: 'ax-road/zones/:id/edit',
                    name: 'axRoadEditZone',
                    components: {
                        parent: ZonesView,
                        child: ZoneEditView,
                    },
                },
                {
                    path: 'ax-road/zones/:id/history',
                    name: 'axRoadZoneHistory',
                    components: {
                        parent: ZonesView,
                        child: ZoneDetailsView,
                        subchild: ZoneDetailsHistoryView,
                    },
                },
                {
                    path: 'ax-road/zones/:id/:assetId',
                    name: 'axRoadZoneTruckDetails',
                    components: {
                        parent: ZonesView,
                        child: ZoneDetailsView,
                        subchild: TripHistoryView,
                    },
                },
                {
                    path: 'ax-road/search',
                    name: 'axRoadSearch',
                    components: {
                        parent: RadialSearchView,
                    },
                },
                {
                    path: 'ax-road/search/results',
                    name: 'axRoadSearchResults',
                    components: {
                        parent: RadialSearchView,
                        child: RadialSearchResultsView,
                    },
                },
                {
                    path: 'ax-road/search/results/:id',
                    name: 'axRoadSearchResultDetails',
                    components: {
                        parent: RadialSearchView,
                        child: RadialSearchResultsView,
                        subchild: TripHistoryView,
                    },
                },
                {
                    path: 'ax-road/settings',
                    name: 'axRoadSettings',
                    components: {
                        parent: SettingsView,
                    },
                },
                {
                    path: '',
                    name: 'search',
                    component: SearchView,
                    children: [
                        {
                            path: 'animal-activity-chart',
                            name: 'globalAnimalActivityChart',
                            component: AnimalActivityChartView,
                            beforeEnter: (to, from, next) =>
                                store.getters['auth/hasActivityAccess']
                                    ? next()
                                    : next(false),
                        },
                    ],
                },
                {
                    path: 'navigation',
                    name: 'navigation',
                    component: NavigationView,
                },
                {
                    path: 'connection-heatmap',
                    name: 'connectionHeatmap',
                    component: ConnectionHeatmapView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/isOriginalSuperuser']
                            ? next()
                            : next(false),
                },
                {
                    path: 'location/create',
                    name: 'createlocation',
                    component: CreateLocationView,
                },
                {
                    path: 'location/:id',
                    name: 'location',
                    component: LocationDetailView,
                    props: true,
                    children: [
                        {
                            path: 'animal-activity-chart',
                            name: 'locationAnimalActivityChart',
                            component: AnimalActivityChartView,
                            props: true,
                            meta: { isChart: true },
                            beforeEnter: (to, from, next) =>
                                store.getters['auth/hasActivityAccess']
                                    ? next()
                                    : next(false),
                        },
                        {
                            path: 'history-chart',
                            name: 'locationHistoryChart',
                            component: LocationHistoryChartView,
                            beforeEnter: (to, from, next) =>
                                store.getters['auth/hasLocationHistoryAccess']
                                    ? next()
                                    : next(false),
                            meta: { isChart: true },
                        },
                    ],
                },
                {
                    path: 'location/:locationId/connection-heatmap',
                    name: 'locationConnectionHeatmap',
                    component: ConnectionHeatmapView,
                    props: true,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/isOriginalSuperuser']
                            ? next()
                            : next(false),
                },
                {
                    path: 'location/:id/edit',
                    name: 'editlocation',
                    component: EditLocationView,
                    props: true,
                },
                {
                    path: 'assets',
                    name: 'allAssets',
                    component: AssetListView,
                    props: { type: 'ASSETS_ALL' },
                },
                {
                    path: 'asset-types',
                    name: 'assetTypes',
                    component: AssetTypeListView,
                },
                {
                    path: 'asset-types/:assetType',
                    name: 'assetTypeAssets',
                    component: AssetListView,
                    props: { type: 'ASSET_TYPE' },
                },
                {
                    path: 'assets/:id',
                    alias: getAssetDetailsAliases(),
                    name: 'detail',
                    component: AssetDetailView,
                    props: true,
                    children: [
                        {
                            path: 'scheme',
                            name: 'assetScheme',
                            component: AssetSchemeView,
                        },
                        {
                            path: 'status-chart/:dataType/:labelPair',
                            name: 'statuschartview',
                            component: AssetStatusChartView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'tachograph',
                            name: 'tachograph',
                            component: AssetTachographView,
                            meta: { isChart: true },
                        },
                        {
                            path: 'tree-history-moisture-chart',
                            name: 'treehistorymoisturechart',
                            component: TreeMoistureChartsView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'tree-history-temperature-chart',
                            name: 'treehistorytemperaturechart',
                            component: TreeTemperatureChartsView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'cm2-simple-chart',
                            name: 'cm2simplechart',
                            component: CM2ChartsView,
                            props: route => ({
                                assetType: 'cm2-simple',
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'cm2-humidity-chart',
                            name: 'cm2humiditychart',
                            component: CM2ChartsView,
                            props: route => ({
                                assetType: 'cm2-humidity',
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'fence-guard-status-chart',
                            name: 'fenceGuardStatusChart',
                            component: AssetFenceGuardStatusChartView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'location-history-chart',
                            name: 'assetLocationHistoryChart',
                            component: LocationHistoryChartView,
                            beforeEnter: (to, from, next) =>
                                store.getters['auth/hasLocationHistoryAccess']
                                    ? next()
                                    : next(false),
                            meta: { isChart: true },
                        },
                        {
                            path: 'beacon-history-chart',
                            name: 'assetBeaconHistoryChart',
                            component: BleHistoryChartView,
                            meta: { isChart: true },
                        },
                        {
                            path: 'gateway-history-chart',
                            name: 'assetGatewayHistoryChart',
                            component: BleHistoryChartView,
                            meta: { isChart: true },
                        },
                        {
                            path: 'sbb-bin-chart',
                            name: 'sbbbinchart',
                            component: BinFillLevelChartView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'dynamic-bin-chart',
                            name: 'dynamicbinchart',
                            component: BinFillLevelChartView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'animal-activity-chart',
                            name: 'animalactivitychart',
                            component: AnimalActivityChartView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'combined-chart',
                            name: 'chartsCombined',
                            component: AssetChartsCombinedView,
                            beforeEnter: (to, from, next) =>
                                to.query.measurement?.length
                                    ? next()
                                    : next({
                                          name: 'detail',
                                          params: { id: to.params.id },
                                      }),
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'measurements-chart/:measurement',
                            name: 'chartsMeasurements',
                            component: AssetCustomMeasurementsChartView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                        {
                            path: 'network-chart',
                            name: 'networkChart',
                            component: NetworkChartView,
                            props: true,
                            beforeEnter: (to, from, next) =>
                                store.getters['auth/hasDebugAccess']
                                    ? next()
                                    : next(false),
                            meta: { isChart: true },
                        },
                        {
                            path: 'running-time-chart',
                            name: 'runningTimeChart',
                            component: RunningTimeChartView,
                            props: true,
                            beforeEnter: (to, from, next) =>
                                store.getters['auth/hasRunningTimeAccess']
                                    ? next()
                                    : next(false),
                            meta: { isChart: true },
                        },
                        {
                            path: ':dataType-chart',
                            name: 'charts',
                            component: AssetChartsView,
                            props: route => ({
                                ...route.params,
                                ...route.query,
                            }),
                            meta: { isChart: true },
                        },
                    ],
                },
                {
                    path: 'assets/:id/connection-heatmap',
                    alias: getAssetDetailsAliases('/connection-heatmap'),
                    name: 'assetConnectionHeatmap',
                    component: ConnectionHeatmapView,
                    props: route => ({ assetId: route.params.id }),
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/isOriginalSuperuser']
                            ? aliasPreservingGuard(to, from, next)
                            : next(false),
                },
                {
                    path: 'assets/:id/edit',
                    alias: getAssetDetailsAliases('/edit'),
                    name: 'editAsset',
                    component: EditAssetView,
                    props: true,
                    beforeEnter: aliasPreservingGuard,
                },
                {
                    path: 'assets/:id/location-history',
                    alias: getAssetDetailsAliases('/location-history'),
                    name: 'locationhistory',
                    component: AssetLocationHistory,
                    props: route => ({
                        ...route.params,
                        ...route.query,
                    }),
                    beforeEnter: aliasPreservingGuard,
                },
                {
                    path: 'assets/:id/trip-history',
                    alias: getAssetDetailsAliases('/trip-history'),
                    name: 'triphistory',
                    component: AssetLocationHistory,
                    props: route => ({
                        ...route.params,
                        ...route.query,
                    }),
                    beforeEnter: aliasPreservingGuard,
                },
                {
                    path: 'deveui/:deveui',
                    beforeEnter: async (to, from, next) => {
                        await commonService.populateData()
                        const tracker = store.state.tracker.trackers.find(
                            ({ deveui }) => deveui === to.params.deveui
                        )
                        if (tracker) {
                            next(`/map/assets/${tracker.id}`)
                        } else {
                            console.log('No tracker found for given DevEUI')
                            next('/map')
                        }
                    },
                },
            ],
        },

        {
            path: '/dashboard',
            component: DashboardLayout,
            meta: {
                requiresAuth: true,
            },
            beforeEnter: (to, from, next) =>
                store.getters['auth/hasDashboardAccess'] ? next() : next(false),
            children: [
                {
                    path: '',
                    name: 'dashboardOverview',
                    component: DashboardOverviewView,
                },
                {
                    path: 'assets',
                    name: 'dashboardAssets',
                    component: DashboardAssetsView,
                },
                {
                    path: 'generic-chart',
                    name: 'dashboardGenericChart',
                    component: DashboardGenericChartView,
                },
                {
                    path: 'location-history',
                    name: 'dashboardLocationHistoryChart',
                    component: DashboardLocationHistoryView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasLocationHistoryAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'e-truck',
                    name: 'etruckDashboard',
                    component: EtruckDashboardView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasEtruckDashboardAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'maintenance-history',
                    name: 'dashboardMaintenanceHistory',
                    component: DashboardMaintenanceHistoryView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasMaintenanceAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'reports',
                    name: 'dashboardReports',
                    component: DashboardReportingHistoryView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasReportingAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'scan-rfid',
                    name: 'dashboardRfid',
                    component: DashboardRfidView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasRfidAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'settings',
                    name: 'dashboardSettings',
                    component: DashboardSettingsView,
                },
                {
                    path: 'sharing-tokens',
                    name: 'sharingTokens',
                    component: DashboardSharingTokensView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasSharingAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'tachograph',
                    name: 'dashboardTachographHistory',
                    component: DashboardTachographHistoryView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasTachographAccess']
                            ? next()
                            : next(false),
                },
                {
                    path: 'users',
                    name: 'dashboardUsers',
                    component: DashboardUsersView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasUserManagementAccess']
                            ? next()
                            : next(false),
                },
            ],
        },

        {
            path: '/ecoscore',
            component: EcoScoreLayout,
            meta: {
                requiresAuth: true,
            },
            beforeEnter: (to, from, next) =>
                store.getters['auth/hasEcoScoreAccess'] ? next() : next(false),
            children: [
                {
                    path: '',
                    name: 'ecoScoreOverview',
                    component: EcoScoreOverviewView,
                },
                {
                    path: 'arv',
                    name: 'ecoScoreArv',
                    component: EcoScoreArvView,
                },
                {
                    path: 'drivers',
                    name: 'ecoScoreDrivers',
                    component: EcoScoreDriverView,
                },
                {
                    path: 'trucks',
                    name: 'ecoScoreTrucks',
                    component: EcoScoreTruckView,
                },
            ],
        },

        {
            path: '/arv',
            component: ArvLayout,
            redirect: { name: 'arvDashboard' },
            meta: {
                requiresAuth: true,
            },
            beforeEnter: (to, from, next) =>
                store.getters['auth/hasArvAccess'] ? next() : next(false),
            children: [
                {
                    path: 'dashboard',
                    name: 'arvDashboard',
                    component: ArvDashboardView,
                },
                {
                    path: 'activities',
                    name: 'arvActivities',
                    component: ArvActivitiesView,
                },
                {
                    path: 'deadlines',
                    name: 'arvDeadlines',
                    component: ArvDeadlinesView,
                },
                {
                    path: 'violations',
                    name: 'arvViolations',
                    component: ArvViolationsView,
                },
                {
                    path: 'evaluations',
                    name: 'arvEvaluations',
                    component: ArvEvaluationsView,
                },
                {
                    path: 'reports',
                    name: 'arvReports',
                    component: ArvReportsView,
                },
            ],
        },

        {
            path: '/change-password',
            name: 'changePassword',
            meta: {
                requiresAuth: true,
            },
            component: ChangePasswordView,
        },

        {
            path: '/lsva',
            component: LsvaLayout,
            meta: {
                requiresAuth: true,
            },
            beforeEnter: (to, from, next) =>
                store.getters['auth/hasLsvaAccess'] ? next() : next(false),
            children: [
                {
                    path: '',
                    name: 'lsvaOverview',
                    component: LsvaOverviewView,
                },
                {
                    path: 'declarations/:date',
                    name: 'lsvaDeclarations',
                    component: LsvaOverviewView,
                },
                {
                    path: 'trailers',
                    name: 'lsvaTrailers',
                    component: LsvaTrailersView,
                },
                {
                    path: 'trucks',
                    name: 'lsvaTrucks',
                    component: LsvaTrucksView,
                },
                {
                    path: 'dashboard',
                    name: 'lsvaDashboard',
                    component: LsvaDashboardView,
                    beforeEnter: (to, from, next) =>
                        store.getters['auth/hasLsvaCharteraAccess']
                            ? next()
                            : next(false),
                },
            ],
        },

        {
            path: '/message-stream',
            name: 'messageStream',
            component: MessageStreamView,
        },

        {
            path: '/rules',
            component: RulesLayout,
            meta: {
                requiresAuth: true,
            },
            beforeEnter: (to, from, next) =>
                store.getters['auth/hasRulesAccess'] &&
                (!store.getters['auth/isAxRoad'] ||
                    store.getters['auth/hasAdvancedRuleAccess'])
                    ? next()
                    : next(false),
            children: [
                {
                    path: '',
                    name: 'ruleList',
                    component: RuleListView,
                    props: route => ({
                        queryAssets: route.query.assets
                            ?.split(',')
                            .map(i => parseInt(i)),
                        queryLocations: route.query.locations
                            ?.split(',')
                            .map(i => parseInt(i)),
                    }),
                },
                {
                    path: 'templates',
                    name: 'ruleTemplates',
                    component: RuleTemplatesView,
                },
                {
                    path: 'create',
                    name: 'ruleCreate',
                    props: true,
                    component: RuleEditView,
                },
                {
                    path: ':id',
                    name: 'ruleEdit',
                    component: RuleEditView,
                },
            ],
        },

        {
            path: '/login',
            component: PublicLayout,
            beforeEnter: (to, from, next) =>
                store.state.auth.jwt ? next('/') : next(),
            children: [
                {
                    path: '',
                    name: 'login',
                    component: LoginView,
                    props: true,
                },
            ],
        },

        {
            path: '/verify-password-reset',
            component: PublicLayout,
            children: [
                {
                    path: '',
                    name: 'passwordReset',
                    component: PasswordResetView,
                    props: route => ({
                        ...route.params,
                        ...route.query,
                    }),
                },
            ],
        },

        {
            path: '/share/:token',
            component: SharingLayout,
            meta: { isSharing: true },
            beforeEnter: (to, from, next) => {
                store.dispatch('auth/logout')
                next()
            },
            children: [
                {
                    path: 'assets/:id',
                    name: 'sharedAssetDetails',
                    component: SharedAssetDetailsView,
                    props: true,
                },
            ],
        },

        {
            path: '/demo',
            children: [
                {
                    path: '',
                    beforeEnter: async (to, from, next) => {
                        await store.dispatch('auth/login', {
                            username: process.env.VUE_APP_DEMO_USERNAME,
                            password: process.env.VUE_APP_DEMO_PASSWORD,
                        })
                        await store.dispatch('auth/loadUserInfo')
                        store.commit('common/setDemoType', 'ax-track')
                        next(process.env.VUE_APP_DEMO_TARGET)
                        store.dispatch('common/loadData')
                    },
                },
                {
                    path: ':demoType',
                    beforeEnter: async (to, from, next) => {
                        await store.dispatch('auth/login', {
                            username: process.env.VUE_APP_DEMO_USERNAME,
                            password: process.env.VUE_APP_DEMO_PASSWORD,
                        })
                        store.commit('common/setDemoType', to.params.demoType)
                        switch (to.params.demoType) {
                            case 'ax-city':
                                next(process.env.VUE_APP_AX_CITY_TARGET)
                                break
                            case 'ax-sports':
                                store.dispatch(
                                    'preferences/updatePreferences',
                                    {
                                        mapDisplayPreferences: {
                                            clusteringEnabled: !store.state
                                                .preferences
                                                .mapDisplayPreferences
                                                .clusteringEnabled,
                                        },
                                    }
                                )
                                next(process.env.VUE_APP_AX_SPORTS_TARGET)
                                break
                            case 'ax-collect':
                                next(process.env.VUE_APP_AX_COLLECT_TARGET)
                                break
                            case 'ax-track':
                                next(process.env.VUE_APP_AX_TRACK_TARGET)
                                break
                            default:
                                store.commit('common/setDemoType', 'ax-track')
                                next(process.env.VUE_APP_DEMO_TARGET)
                                break
                        }
                        store.dispatch('common/loadData')
                    },
                },
            ],
        },

        // Catch all
        { path: '*', redirect: '/map' },
    ],
})

router.beforeEach(async (to, from, next) => {
    if (to.path.startsWith('/map')) {
        store.commit('tracker/setShouldUpdateTrackers', false)
    }

    if (to.path.startsWith('/map/assets/')) {
        if (store.getters['auth/isAxRoad']) {
            next({ name: 'axRoadTruckDetails', params: to.params })
        }
    }

    if (
        to.matched.some(record => record.meta.requiresAuth) &&
        !(await store.dispatch('auth/refreshTokenIfNecessary'))
    ) {
        const params = to.path ? { nextUrl: { path: to.path } } : null
        next({ name: 'login', params })
        return
    }

    next()
})

router.afterEach(to => {
    if (to.fullPath.startsWith('/map')) {
        store.commit('tracker/setShouldUpdateTrackers', true)
    }
})

export default router
